const BLOCK_SELECTOR = [
  ".page-header",
  ".content-section",
  ".footer-cta",
  ".why-transpond-section",
  ".step-section",
  ".integrations-section",
  ".agency-banner",
  ".resources__section",
  ".about__section",
  ".pricing-table__wrapper",
  ".saas-rise-header",
  ".key-stats",
  ".section--white",
  ".customer-logos",
  ".blog-promo-banner",
].join(",");

const SKIP_INSIDE =
  ".nav, .nav-container, .mega-menu, footer, .site-footer, .support-article, .article-body, .blog-article, .blog-page";

function prefersReducedMotion() {
  return (
    typeof window !== "undefined" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches
  );
}

function isNestedBlock(el) {
  const parentBlock = el.parentElement && el.parentElement.closest(BLOCK_SELECTOR);
  return Boolean(parentBlock && parentBlock !== el);
}

function isInView(el) {
  const rect = el.getBoundingClientRect();
  const viewBottom = window.innerHeight * 0.9;
  return rect.top < viewBottom && rect.bottom > 64;
}

function collectTargets(root) {
  const seen = new Set();
  const add = (el) => {
    if (!el || seen.has(el)) return;
    if (el.closest(SKIP_INSIDE)) return;
    if (el.classList.contains("hero-fade-in") || el.querySelector(".hero-fade-in")) {
      return;
    }
    if (el.classList.contains("scroll-reveal")) return;
    if (isNestedBlock(el)) return;
    seen.add(el);
  };

  root.querySelectorAll(BLOCK_SELECTOR).forEach(add);

  root.querySelectorAll("section").forEach((el) => {
    if (el.matches(BLOCK_SELECTOR)) return;
    if (el.parentElement && el.parentElement.closest("section")) return;
    if (el.offsetHeight < 80) return;
    add(el);
  });

  return [...seen];
}

function revealNow(el, animate = false) {
  el.classList.add("scroll-reveal");
  if (!animate) {
    el.classList.add("is-visible");
    return;
  }
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      el.classList.add("is-visible");
    });
  });
}

function bindTarget(el, observer) {
  if (el.dataset.scrollRevealBound) return;
  el.dataset.scrollRevealBound = "1";

  if (isInView(el)) {
    revealNow(el, true);
    return;
  }

  el.classList.add("scroll-reveal");
  observer.observe(el);
}

export function setupPageScrollReveal(root = document) {
  if (typeof window === "undefined") return () => {};

  if (prefersReducedMotion()) {
    collectTargets(root).forEach(revealNow);
    return () => {};
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add("is-visible");
        observer.unobserve(entry.target);
      });
    },
    {
      // Any visible part counts. A ratio threshold never fires for a section
      // taller than the viewport, which left long pages stuck at opacity 0.
      threshold: 0,
      rootMargin: "0px 0px -10% 0px",
    }
  );

  const apply = () => {
    collectTargets(root).forEach((el) => bindTarget(el, observer));
  };

  apply();

  const moRoot = root.querySelector("#app") || root.body || root;
  const mutations = new MutationObserver(apply);
  if (moRoot && moRoot.nodeType === 1) {
    mutations.observe(moRoot, { childList: true, subtree: true });
  }

  return () => {
    observer.disconnect();
    mutations.disconnect();
  };
}
